import {
  CrosshairsTool,
  PanTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useState, useEffect, useMemo } from "react";
import { HIDE_TOOL_SMALL_SCREEN, TOAST_TYPE, VIEWPORT_TOOLS, SYNC_MODES } from "../../../../../constants/Constants";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { Enums, annotation } from "@cornerstonejs/tools";
import { eventTarget } from "@cornerstonejs/core";
import {
  enableVOISync,
  FlipHorizontally,
  FlipVertically,
  getViewport,
  loadMPR,
  originalResolution,
  reset,
  resizeViewport,
  setInvert,
  setRotation,
  setStackPosition,
} from "../../../helpers/CornerstoneViewportService";
import { HP_VIEWPORT_ALIGNMENT } from "../../../../../constants/Constants";
import GetToolSVG from "./GetToolSVG";
import WindowLevelToolComponent from "./WindowLevelToolComponent";
import Viewport from "../../Viewport/Viewport";
import { useTranslation } from "react-i18next";
import {
  canAttemptMPR,
  createSeriesData,
  isReconstructable,
  startLoaderIfSlow,
  waitForNextPaint,
} from "../../../helpers/MPRService";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import toastContext from "../../../../../context/toast/ToastContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import StackScrollToolComponent from "./StackScrollToolComponent";
import ZoomToolComponent from "./ZoomToolComponent";
import FreeRotateToolComponent from "./FreeRotateToolComponent";
import { toolStyle, toolTipStyles } from "../../../styles/styles";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../../helpers/StackScrollSyncService";
// import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import $ from "jquery";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
import { formatBasicViewerToolTooltip } from "../../../helpers/basicViewerToolShortcuts";
import {
  createMouseButtonAssignmentPointerDownCaptureHandler,
  suppressMouseButtonAssignmentContextMenu,
  ToolbarMouseAssignmentIndicators,
} from "./mouseButtonToolbarUtils";

const Tool = ({ tool }) => {
  const { showToastv2 } = useContext(toastContext);
  const [hovered, setHovered] = useState(false);
  const [cineState, setCineState] = useState(false);
  const {
    activeTool,
    setActiveTool,
    previousActiveTool,
    setPreviousActiveTool,
    activeViewportIndex,
    annotationDataAI,
    addedAnnotation,
    boundingBox,
    setIsCineEnabled,
    isCineEnabled,
    setIsSynchronizedEnabled,
    isSynchronizedEnabled,
    // Reference Lines toggle (mirrors desktop DropDownToolElement).
    isReferenceLinesEnabled,
    setIsReferenceLinesEnabled,
    setIsReferenceLineActivated,
    setIsMPRActive,
    isMPRActive,
    viewportElements,
    viewportSeriesData,
    mprLoading,
    setMprLoading,
    activeMPRTool,
    setActiveMPRTool,
    activeMPRViewportIndex,
    setIsCompareActive,
    isCompareActive,
    viewportRow,
    viewportColumn,
    changeLayout,
    setMprViewportElements,
    setIsMPRViewportActivated,
    setMPRViewportLoaderRunning,
    setVolumeId,
    handleDefaultToolChange,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable,
    setIsCropEnable,
    syncMode,
    setSyncMode,
    linkedViewports,
    assignMouseButtonToAssignableTool,
    mouseButtonToolAssignments,
    // clear spine-label points on Reset (same as desktop DropDownToolElement).
    spineLabels,
    setSpineLabels,
    setSpinePhase,
    lockViewportAlignment,
    unlockViewportAlignment,
  } = useContext(ViewportContext);

  const { setActiveMPRThumbnailIndex, activeThumbnailIndex } =
    useContext(ThumbnailContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);

  const { setProgressComplete, setProgress, setShowToast } =
    useContext(studyviewerContext);

  const { username } = useContext(userContext);

  const { t } = useTranslation();

  const tooltipId = `basic-viewer-tool-${tool.key}`;
  const tooltipContent = useMemo(() => {
    if (isMobile) {
      return "";
    }
    return formatBasicViewerToolTooltip(t(tool.name), tool.key);
  }, [isMobile, t, tool.name, tool.key]);

  const changeActiveTool = async (tool) => {
    // eventTarget.reset();
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    
    if (!isBBMode && !isCropMode && activeTool === tool.key) {
      setPreviousActiveTool(activeTool);
      // setActiveTool(StackScrollTool.toolName);
      handleDefaultToolChange();
    } else {
      setPreviousActiveTool(activeTool);
      assignMouseButtonToAssignableTool("primary", tool.key, true);
      setActiveTool(tool.key);
      if (tool.isEvent) {
        // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    }
  };

  const toggleMPR = async (tool) => {
    if (isMPRActive) {
      return;
    }

    // Two-phase entry, deliberately:
    //
    // Phase 1 — a cheap first-slice-only gate (canAttemptMPR) so a series that
    // can never be reconstructed at all (wrong modality, single slice, one
    // slice already too big for the volume budget) is rejected without the
    // layout ever flipping into MPR and straight back out.
    //
    // Phase 2 — flip into MPR and let React paint the 3-pane layout WITH its
    // spinner before the expensive whole-series geometry check and volume load
    // run. Doing that heavy work ahead of the flip (as this used to) blocked
    // the main thread while nothing on screen had changed yet: the click looked
    // like it had done nothing at all, and then the viewer jumped straight to
    // fully rendered MPR images without the loader ever being visible.
    const stopGateLoader = startLoaderIfSlow(ref);
    let canAttempt;
    try {
      canAttempt = await canAttemptMPR(activeViewportIndex, "viewport");
    } catch (error) {
      console.error("[MPR] reconstructability pre-check failed:", error);
      canAttempt = { value: false };
    } finally {
      stopGateLoader();
    }

    if (!canAttempt.value) {
      showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
      return;
    }

    setMPRViewportLoaderRunning(true);
    setActiveMPRTool(CrosshairsTool.toolName);
    setActiveMPRThumbnailIndex(activeThumbnailIndex);
    setIsMPRActive(true);
    // Hand the frame back so the MPR panes are on screen (spinner running)
    // before anything expensive starts.
    await waitForNextPaint();

    const isSeriesReconstructable = await isReconstructable(
      activeViewportIndex,
      "viewport"
    );

    if (!isSeriesReconstructable.value) {
      // Only the full geometry check can reject on spacing/orientation, so a
      // series that cleared phase 1 and fails here has to be backed out of
      // MPR mode again.
      setIsMPRActive(false);
      setMPRViewportLoaderRunning(false);
      showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
      return;
    }
    if (isSeriesReconstructable.hasDuplicateSlice) {
      showToastv2(TOAST_TYPE.WARNING, t("mpr.duplicate-slice-warning"));
    }
    if (isSeriesReconstructable.excludedImageIds?.length) {
      showToastv2(TOAST_TYPE.WARNING, t("mpr.excluded-instances-warning"));
    }

    (async () => {
      try {
        await loadMPR(
          activeViewportIndex,
          "viewport",
          viewportSeriesData[activeViewportIndex].series,
          setMprLoading,
          setMprViewportElements,
          setIsMPRViewportActivated,
          setVolumeId,
          isSeriesReconstructable.excludedImageIds
        );
      } catch (error) {
        console.error("[MPR] failed to load volume:", error);
        setIsMPRActive(false);
        setMPRViewportLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR, t("mpr.load-failed"));
      }
    })();
    enableVOISync();
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleCompareClick = async () => {
    if (viewportRow === 1 && viewportColumn === 1 && !isCompareActive) {
      changeLayout(1, 2);
    }
    setIsCompareActive(!isCompareActive);
  };

  const handleViewportClickTool = async (tool) => {
    switch (tool.key) {
      case "Invert":
        await setInvert(activeViewportIndex);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateRight":
        await setRotation(activeViewportIndex, 90);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateLeft":
        await setRotation(activeViewportIndex, -90);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipVertical":
        await FlipVertically(activeViewportIndex);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipHorizontal":
        await FlipHorizontally(activeViewportIndex);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignLeft":
        // An explicit Align is the radiologist placing the image themselves, so
        // it takes off any lock first — otherwise the lock drags it straight back.
        unlockViewportAlignment(activeViewportIndex);
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.LEFT);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignRight":
        unlockViewportAlignment(activeViewportIndex);
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.RIGHT);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "AlignCenter":
        unlockViewportAlignment(activeViewportIndex);
        await setStackPosition(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.CENTER);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      // Locking writes the lock and nothing else: the viewport's own lock effect
      // is what puts the image on that edge and keeps it there. Taking the lock
      // off again is the padlock on the viewport overlay.
      case "LockLeft":
        lockViewportAlignment(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.LEFT);
        break;
      case "LockRight":
        lockViewportAlignment(activeViewportIndex, HP_VIEWPORT_ALIGNMENT.RIGHT);
        break;
      case "Reset":
        // Reset is the clean slate, and the escape hatch. It already discards
        // rotation, flip and windowing, so an alignment lock goes with them -
        // and it has to go BEFORE the camera reset below, which a live lock
        // would misread as a zoom and answer by shoving the image off-canvas.
        unlockViewportAlignment(activeViewportIndex);
        await reset(activeViewportIndex, boundingBox, annotationDataAI, addedAnnotation);
        if (spineLabels.length > 0) {
          setSpineLabels([]);
          setSpinePhase("select");
        }
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "CINE":
        setIsCineEnabled(!isCineEnabled);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Synchronize":
        if (!isSynchronizedEnabled) {
          const mode = SYNC_MODES.AUTOMATIC;
          setSyncMode(mode);
          enableStackScrollSync(
            activeViewportIndex,
            mode,
            viewportSeriesData,
            null
          );
          setIsSynchronizedEnabled(true);
          if (tool.isEvent) {
            // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
          }
        } else {
          disableStackScrollSync();
          setIsSynchronizedEnabled(false);
        }
        break;
      case "ReferenceLines":
        // Reference Lines toggle (mirrors desktop DropDownToolElement).
        // (isReferenceLinesEnabled drives toggleReferenceLines in Viewport.jsx).
        setIsReferenceLineActivated(!setIsReferenceLineActivated);
        setIsReferenceLinesEnabled(!isReferenceLinesEnabled);
        if (tool.isEvent) {
          // logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      default:
        break;
    }
    if (
      isMobile &&
      VIEWPORT_TOOLS.includes(tool.key)
    ) {
      handleDefaultToolChange();
    }
    const viewportContainer = $(`#viewport-box-${activeViewportIndex}`);
    viewportContainer.addClass("blinking");
    setTimeout(() => {
      viewportContainer.removeClass("blinking");
    },1000)
  };

  if (tool.key === WindowLevelTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <WindowLevelToolComponent
            toolName={tool.key}
            hovered={hovered}
            tool={tool}
          />
        </div>
      </>
    );
  }

  if (tool.key === StackScrollTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <StackScrollToolComponent tool={tool} />
        </div>
      </>
    );
  }

  if (tool.key === ZoomTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <ZoomToolComponent tool={tool} />
        </div>
      </>
    );
  }

  if (tool.key === "FreeRotate") {
    return (
      <>
        <div style={toolStyle}>
          <FreeRotateToolComponent tool={tool} />
        </div>
      </>
    );
  }
  
  if (tool.key === PanTool.toolName) {
    return (
      <>
        <div
          style={toolStyle}
          className={`${
            HIDE_TOOL_SMALL_SCREEN.includes(tool.key) ? "hide-tool" : ""
          }`}
        >
          <CustomToolTipHost
            delay={TooltipDelay.zero}
            id={tooltipId}
            directionalHint={DirectionalHint.bottomCenter}
            styles={toolTipStyles}
            content={tooltipContent}
          >
            {isMobile ? (
              <div
                onClick={() => changeActiveTool(tool)}
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                aria-describedby={tooltipId}
              >
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="highlight-tool-mobile">
                    <GetToolSVG toolName={tool.key} hovered={false} />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "var(--mobile-color-txt)",
                    display: "block",
                    width: "60px",
                    textAlign: "center",
                  }}
                >
                  {t(tool.name)}
                </span>
              </div>
            ) : (
              <div className="highlight-tool">
                <div
                  className="tool-with-mouse"
                  style={{
                    height: "100%",
                    position: "relative",
                  }}
                  onClick={() => changeActiveTool(tool)}
                  onPointerDownCapture={createMouseButtonAssignmentPointerDownCaptureHandler(
                    PanTool.toolName,
                    assignMouseButtonToAssignableTool
                  )}
                  onContextMenu={suppressMouseButtonAssignmentContextMenu}
                  onContextMenuCapture={suppressMouseButtonAssignmentContextMenu}
                  onMouseOver={handleMouseOver}
                  onMouseLeave={handleMouseLeave}
                  aria-describedby={tooltipId}
                >
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                  <ToolbarMouseAssignmentIndicators
                    toolName={PanTool.toolName}
                    assignments={mouseButtonToolAssignments}
                  />
                </div>
              </div>
            )}
          </CustomToolTipHost>
        </div>
      </>
    );
  }

  if (tool.key === "MPR") {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={tooltipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={tooltipContent}
        >
          <div
            onClick={() => toggleMPR(tool.key)}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={{ ...toolStyle, margin: "0 0 0 10px" }}
            aria-describedby={tooltipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "#FFFFFF",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <GetToolSVG toolName={tool.key} hovered={hovered} />
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }

  if (tool.key === "Compare") {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={tooltipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={tooltipContent}
        >
          <div
            onClick={handleCompareClick}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={{ ...toolStyle, margin: "0 5px 0 0" }}
            aria-describedby={tooltipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "#FFFFFF",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <GetToolSVG toolName={tool.key} hovered={hovered} />
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }

  if (!VIEWPORT_TOOLS.includes(tool.key)) {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={tooltipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={tooltipContent}
        >
          <div
            onClick={() => changeActiveTool(tool)}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={toolStyle}
            className={`${HIDE_TOOL_SMALL_SCREEN.includes(tool.key)?"hide-tool":""}`}
            aria-describedby={tooltipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={
                      isMobile ? "highlight-tool-mobile" : "highlight-tool"
                    }
                  >
                    <GetToolSVG toolName={tool.key} hovered={hovered} />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    // color: "#FFFFFF",
                    color: "var(--mobile-color-txt)",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <div className="highlight-tool">
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  } else {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={tooltipId}
          directionalHint={DirectionalHint.bottomCenter}
          styles={toolTipStyles}
          content={tooltipContent}
        >
          <div
            onClick={() => {
              handleViewportClickTool(tool);
            }}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={toolStyle}
            aria-describedby={tooltipId}
            className={`${HIDE_TOOL_SMALL_SCREEN.includes(tool.key)?"hide-tool":""}`}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={
                      isMobile ? "highlight-tool-mobile" : "highlight-tool"
                    }
                  >
                    <GetToolSVG toolName={tool.key} hovered={hovered} />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <div className="highlight-tool">
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }
};

export default Tool;
